var map = {
	"./determine/Detoxification.jpg": 13219,
	"./determine/Hydration.jpg": 44382,
	"./determine/MentalFitness.jpg": 1594,
	"./determine/Movement.jpg": 55087,
	"./determine/Nature.jpg": 69948,
	"./determine/Nutrition.jpg": 64958,
	"./determine/Relationships.jpg": 41461,
	"./determine/RestSelfCare.jpg": 82323,
	"./determine/Sleep.jpg": 20599,
	"./determine/Vision.jpg": 35264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71732;